import { render, staticRenderFns } from "./mobile-tree.vue?vue&type=template&id=064e7cf8&scoped=true&"
import script from "./mobile-tree.vue?vue&type=script&lang=ts&"
export * from "./mobile-tree.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-tree.vue?vue&type=style&index=0&id=064e7cf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e7cf8",
  null
  
)

export default component.exports